<style>
@import '../../custom/css/ver-dica.css';
</style>

<template>
  <div id="editar-cliente" class="editar-dica">
    <div class="form-fields position-relative" v-if="cliente !== null">
      <h1 class="title text-uppercase font-weight-bold">Editar Cliente</h1>
      <hr class="linha-amarela" />
      <div class="row" v-if="dados !== null">
        <div class="col-12">
          <div class="form-group">
            <label for="cadastroNome">Nome Completo</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.nome.value"
              id="cadastroNome"
              aria-describedby="Nome para Cadastro"
              :placeholder="cliente[0].nome"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroRG">RG</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.rg.value"
              id="cadastroRG"
              v-mask="'##.###.###-#'"
              aria-describedby="RG para Cadastro"
              :placeholder="cliente[0].rg"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroCPF">CPF</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.cpf.value"
              id="cadastroCPF"
              v-mask="'###.###.###-##'"
              aria-describedby="CPF para Cadastro"
              :placeholder="cliente[0].cpf"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroCNPJ">CNPJ</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.cnpj.value"
              id="cadastroCNPJ"
              v-mask="'##.###.###/####-##'"
              aria-describedby="CNPJ para Cadastro"
              :placeholder="cliente[0].cnpj"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroCelular">Celular</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.celular.value"
              v-mask="['(##) #####-####', '(##) ####-####']"
              id="cadastroCelular"
              aria-describedby="Celular para Cadastro"
              :placeholder="cliente[0].celular"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroTelefone">Telefone</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.telefone.value"
              v-mask="'(##) ####-####'"
              id="cadastroTelefone"
              aria-describedby="Telefone para Cadastro"
              :placeholder="cliente[0].telefone"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroTelefone2">Telefone 2</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.telefone2.value"
              v-mask="'(##) ####-####'"
              id="cadastroTelefone2"
              aria-describedby="Telefone 2 para Cadastro"
              :placeholder="cliente[0].telefone2"
            />
          </div>
        </div>
        <div class="col-lg-8">
          <div class="form-group">
            <label for="cadastroEndereco">Endereço</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.endereco.value"
              id="cadastroEndereco"
              aria-describedby="Endereço para Cadastro"
              :placeholder="cliente[0].endereco"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroNumero">Número</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.numero.value"
              id="cadastroNumero"
              aria-describedby="Número para Cadastro"
              :placeholder="cliente[0].numero"
            />
          </div>
        </div>
        <div class="col-lg-8">
          <div class="form-group">
            <label for="cadastroComplemento">Complemento</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.complemento.value"
              id="cadastroComplemento"
              aria-describedby="Complemento para Cadastro"
              :placeholder="cliente[0].complemento"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroCep">CEP</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.cep.value"
              id="cadastroCep"
              v-mask="'#####-###'"
              aria-describedby="CEP para Cadastro"
              :placeholder="cliente[0].cep"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="cadastroBairro">Bairro</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.bairro.value"
              id="cadastroBairro"
              aria-describedby="Bairro para cadastro"
              :placeholder="cliente[0].bairro"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="cadastroCidade">Cidade</label>
            <v-select
              id="cadastroCidade"
              label="nome"
              :options="cidades"
              v-model="dados.cidade.value"
              :placeholder="
                cliente[0].cidade_obj !== null ? cliente[0].cidade_obj.nome : ''
              "
            ></v-select>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-group">
            <label for="cadastroEstado">UF</label>
            <v-select
              id="cadastroEstado"
              label="uf"
              :options="estados"
              v-model="dados.estado.value"
              :placeholder="
                cliente[0].estado_obj !== null ? cliente[0].estado_obj.uf : ''
              "
            ></v-select>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="cadastroEmail">E-mail</label>
            <input
              type="text"
              class="form-control"
              v-model="dados.email.value"
              id="cadastroEmail"
              aria-describedby="Email para Cadastro"
              :placeholder="cliente[0].email"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="cadastroSenha">Senha</label>
            <input
              type="password"
              class="form-control"
              v-model="dados.password.value"
              id="cadastroSenha"
              aria-describedby="Senha para Cadastro"
              placeholder="Digite nova senha"
            />
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="btn btn-success" @click="salvarCliente()">Salvar</div>
        <div class="btn btn-voltar-dicas" @click="voltarLista()">Voltar</div>
      </div>
    </div>
    <div class="form-fields" v-else>
      <h1 class="title text-uppercase">Esse cliente não existe mais!</h1>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { setTimeout, setInterval } from 'timers';

export default {
  name: 'editar-cliente',
  data: () => ({
    dados: {
      email: {
        value: null,
      },
      senha: {
        value: null,
      },
      nome: {
        value: null,
      },
      rg: {
        value: null,
      },
      cpf: {
        value: null,
      },
      cnpj: {
        value: null,
      },
      celular: {
        value: null,
      },
      complemento: {
        value: null,
      },
      cep: {
        value: null,
      },
      telefone: {
        value: null,
      },
      telefone2: {
        value: null,
      },
      endereco: {
        value: null,
      },
      numero: {
        value: null,
      },
      bairro: {
        value: null,
      },
      cidade: {
        value: null,
      },
      estado: {
        value: null,
      },
      cep: {
        value: null,
      },
      password: {
        value: null,
      },
    },
  }),
  props: ['id'],
  computed: {
    ...mapState({
      cliente: (state) => state.cliente,
      cidades: (state) => state.cidades,
      estados: (state) => state.estados,
    }),
  },
  created() {
    this.$store.dispatch('startLoader');
    this.$store
      .dispatch('showCliente', this.id)
      .then(() => {
        setTimeout(() => {
          this.$store.dispatch('endLoader');
        }, 1500);
      })
      .catch(() => {
        setTimeout(() => {
          this.$store.dispatch('showCliente', this.id).then(() => {
            this.$store.dispatch('endLoader');
          });
        }, 1500);
      });
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadEstados');
  },
  mounted() {
    this.$store.dispatch('showCliente', this.id).then(() => {
      setTimeout(() => {
        this.dados.email.value = this.cliente[0].email;
        this.dados.nome.value = this.cliente[0].nome;
        this.dados.rg.value = this.cliente[0].rg;
        this.dados.cpf.value = this.cliente[0].cpf;
        this.dados.cnpj.value = this.cliente[0].cnpj;
        this.dados.celular.value = this.cliente[0].celular;
        this.dados.complemento.value = this.cliente[0].complemento;
        this.dados.cep.value = this.cliente[0].cep;
        this.dados.telefone.value = this.cliente[0].telefone;
        this.dados.telefone2.value = this.cliente[0].telefone2;
        this.dados.endereco.value = this.cliente[0].endereco;
        this.dados.numero.value = this.cliente[0].numero;
        this.dados.bairro.value = this.cliente[0].bairro;
        this.dados.estado.value = this.cliente[0].estado_obj;
        this.dados.cidade.value = this.cliente[0].cidade_obj;
      }, 1500);
    });
  },
  methods: {
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    salvarCliente() {
      const self = this;
      const data = {
        id: this.cliente[0].usuario_id,
        id_cliente: this.cliente[0].id,
        email: this.dados.email.value,
        nome: this.dados.nome.value,
        rg: this.dados.rg.value,
        cpf: this.dados.cpf.value,
        cnpj: this.dados.cnpj.value,
        celular: this.dados.celular.value,
        telefone: this.dados.telefone.value,
        telefone2: this.dados.telefone2.value,
        endereco: this.dados.endereco.value,
        complemento: this.dados.complemento.value,
        numero: this.dados.numero.value,
        bairro: this.dados.bairro.value,
        cidade: this.dados.cidade.value,
        estado: this.dados.estado.value,
        cep: this.dados.cep.value,
        password: this.dados.password.value,
      };

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('updateClienteByAdm', data)
        .then((data) => {
          setTimeout(() => {
            this.$store.dispatch('showCliente', this.id);
            setTimeout(() => {
              this.$store.dispatch('endLoader');
              this.aviso('Editado com Sucesso!', 'success');
            });
          }, 1000);
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.aviso('Houve um problema em realizar essa edição!', 'success');
        });
    },
    voltarLista() {
      this.$router.push({
        name: 'administrador-clientes',
      });
    },
  },
};
</script>
